export const Error = ({ message }: { message?: string }) => {
    return <div>
        {message}
    </div>;
};
